<div class="spin" [ngClass]="getClasses()"></div>